import React, {
    useContext,
    useEffect,
    useState,
    useCallback,
    Fragment,
} from 'react';
import { withRouter } from 'react-router-dom';
import { UserContext } from '../contexts/UserContext';
import LoginService from '../services/LoginService';
import { withCookies } from 'react-cookie';
import Globals from '../Globals';
import Loading from './bronson/Loading';
import SellService from './../services/SellService';
import useInterval from '../hooks/useInterval';

import { throttle } from 'Functions';
import { READONLY_PERMISSION } from 'constants/Permissions';

function IsUserLogged({ history, cookies, children }) {
    const {
        user,
        setLogged,
        setUser,
        setPreferences,
        setCifs,
        setBuyerType,
        sethasTransportAvailable,
    } = useContext(UserContext);
    const [loading, setLoading] = useState(false);
    const [delay, setDelay] = useState(null);

    const refreshToken = useCallback(async () => {
        let token = cookies.get(Globals.COOKIES.JWT);
        if (!token) return;
        let result = await refreshTokenAccess(token);
        if (result?.body?.Executed) {
            var cookieJWT = result.body.Token;
            const userToken = cookies.get(Globals.COOKIES.USER);
            let tomorrow = new Date();
            tomorrow.setDate(
                tomorrow.getDate() + parseInt(process.env.REACT_APP_JWT_EXPIRES, 10)
            );
            var cookieOptions = {
                path: process.env.PUBLIC_URL,
                expires: tomorrow,
                maxAge: parseInt(process.env.REACT_APP_JWT_MAXAGE, 10), //in seconds
                // secure: true,
                // httpOnly: true
            };
            cookies.set(Globals.COOKIES.JWT, cookieJWT, cookieOptions);
            cookies.set(Globals.COOKIES.USER, userToken, cookieOptions);
        }
    }, [cookies]);

    useEffect(() => {
        //set interval that checks user session
        setDelay(60000);
        //refresh user session if user clicks on window, can happen once every minute max
        const refreshTokenOnClick = throttle(refreshToken, 60000);
        window.addEventListener('click', refreshTokenOnClick);

        return () => {
            setDelay(null);
            window.removeEventListener('click', refreshTokenOnClick);
        };
    }, [refreshToken]);

    useInterval(refreshToken, 60000);

    const validateURL = useCallback(
        eliminarSesion => {
            if (
                (history.location.pathname ===
                    Globals.APPLICATION_PATH.LEGAL_NOTE ||
                    history.location.pathname ===
                        Globals.APPLICATION_PATH.PRIVACY_POLICY ||
                    history.location.pathname ===
                        Globals.APPLICATION_PATH.COOKIES_POLICY ||
                    history.location.pathname ===
                        Globals.APPLICATION_PATH.LICENCE) &&
                eliminarSesion
            ) {
                return false;
            } else return eliminarSesion;
        },
        [history.location.pathname]
    );

    const refreshContext = useCallback(async () => {
        let eliminarSesion = false;
        const token = cookies.get(Globals.COOKIES.JWT)?.AccessToken;
        const userToken = cookies.get(Globals.COOKIES.USER);

        if (!token || !userToken) {
            eliminarSesion = true;
        } else {
            if (!user.logged) {
                setLoading(true);
                let result = await refreshConnection(token);
                if (result) {
                    if (result.statusCode === 401) {
                        //Refrescar Token
                        eliminarSesion = true;
                    } else if (result.statusCode === 200) {
                        const user = JSON.parse(result.body.Result).User;

                        setUser(user);

                        const readOnly = user.Permissions?.some(
                            ({ NombreConstante }) =>
                                NombreConstante === READONLY_PERMISSION
                        );

                        if (!readOnly) {
                            var data = await new SellService().getBuyers(
                                cookies.get(Globals.COOKIES.JWT).AccessToken,
                                JSON.parse(result.body.Result).User.Empleado.Id
                            );
                            let buyerType = JSON.parse(data.Result)[0]
                                .BuyerType;
                            setBuyerType(buyerType);
                            if (buyerType != null) {
                                sethasTransportAvailable(buyerType === 2);
                            }
                            setPreferences(
                                JSON.parse(result.body.Result).Preferences
                            );
                            setCifs(JSON.parse(result.body.Result).Buyer);
                        }

                        setLogged(true);
                    } else {
                        eliminarSesion = true;
                    }
                } else {
                    eliminarSesion = true;
                }
                setLoading(false);
            }
        }
        if (validateURL(eliminarSesion)) {
            history.push({
                pathname: `${Globals.APPLICATION_PATH.LOGIN}`,
                state: {
                    pendingRefresh: true,
                },
            });
            setLogged(false);
        }
    }, [cookies, history.location, user.logged, validateURL]);

    useInterval(refreshContext, delay);

    useEffect(() => {
        refreshToken();
    }, [refreshToken]);

    useEffect(() => {
        refreshContext();
    }, [refreshContext]);

    const refreshTokenAccess = async token => {
        return await new LoginService().refreshToken(token);
    };

    const refreshConnection = async token => {
        return await new LoginService().refresh(token);
    };

    return (
        <Fragment>
            <Loading ariaBusy={loading} disableIcon={true}></Loading>
            {children}
        </Fragment>
    );
}
export default withCookies(withRouter(IsUserLogged));
